import PropTypes from 'prop-types';

const recipientPropType = PropTypes.shape({
  id: PropTypes.number,
  userId: PropTypes.number,
  transportId: PropTypes.number,
  context: PropTypes.string,
  createdAt: PropTypes.number,
});

export default { recipientPropType };
